export const WISH_LIST = '/wish-list';

export const WISHLIST_URL = `${process.env.REACT_APP_WISH_LIST_REDIRECT_URL}${WISH_LIST}`;
export const WISHLIST_URL_WITH_CREATE_WL_MODAL = `${process.env.REACT_APP_WISH_LIST_REDIRECT_URL}${WISH_LIST}?showCreateWLModal=true`;
